export const STRIPE_ELEMENT_ID = 'stripe-payment-el';
